import React, { useMemo, useContext } from 'react';

import MultiCTACard from 'components/MultiCTACard';
import { useMultiCTACardQuery } from 'hooks/useMultiCTACardQuery';
import useLiveData from 'hooks/useLiveData';
import { PersonalizationContext } from 'components/Personalization/PersonalizationContext';

const MultiCTACardProvider = ({ children, staticData, id }) => {
	const { matchAudience } = useContext(PersonalizationContext);
	const { data } = useMultiCTACardQuery();
	const shouldLimitLiveDataByStaticIds = !staticData;
	const effectiveStaticData = React.useMemo(() => staticData || data || {}, [staticData, data]);
	const MultiCTACardEdges = effectiveStaticData?.allMultiCTACard?.edges || [];
	const MultiCTACardNodes = MultiCTACardEdges.map(({ node }) => node);

	const {
		statusText: MultiCTACardStatusText,
		response: MultiCTACardResponse,
		visibilityChange: MultiCTACardVisibilityChange,
	} = useLiveData({
		namespace: 'SmartTags',
		model: 'MultiCTACard',
		method: 'all',
		graphqlKey: 'allSmartTagsMultiCtaCard',
		apiParams: {
			archived: false,
			approved: true,
			deleted: false,
			_join: 'Audience',
			...(shouldLimitLiveDataByStaticIds && MultiCTACardNodes.length > 0 ? {
				id: MultiCTACardNodes.map((n) => n.id).join(','),
			} : {}),
			...(!!id ? { id } : {}),
		},
		staticData: effectiveStaticData,
	});

	const liveMultiCTACard = MultiCTACardResponse?.data[0];
	let ts = MultiCTACardNodes[0];
	if (!!liveMultiCTACard && MultiCTACardStatusText === 'LOADED') {
		ts = liveMultiCTACard;
	}
	if (!!liveMultiCTACard && MultiCTACardVisibilityChange) ts = liveMultiCTACard;

	const datum = useMemo(() => ts, [ts]);

	if (datum && datum.hasOwnProperty('Audience') && datum?.Audience) {
		if (!matchAudience(datum?.Audience)) {
			return null;
		}
	}

	return (
		<MultiCTACard {...datum} matchAudience={matchAudience} />
	);
};

export default MultiCTACardProvider;